import * as Sentry from '@sentry/browser';

import { LeadHistoryType, ClaimRejectReason } from '../../../../Model/Lead';
import texts from './texts.json';

const sendDesktopNotification = () => {
  try {
    // Check if the browser supports notifications
    if ('Notification' in window) {
      if (Notification.permission === 'granted') {
        const notification = new Notification(texts.notification.title, {
          body: texts.notification.body,
          icon: '/logo192.png',
        });
        // focus the tab
        notification.onclick = () => {
          window.focus();
        };
        // remove the notification after 10 seconds
        setTimeout(() => {
          notification.close();
        }, 10000);
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            sendDesktopNotification();
          }
        });
      }
    }
    // play notification sound
    const audio = new Audio('/notification.wav');
    audio.play();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to send desktop notification:', error);
  }
};

const claimLeadWithHistory = async (leadDoc, userDoc) => {
  if (!leadDoc?.id) {
    return { success: false, leadNoLongerAvailable: true, reason: ClaimRejectReason.MISSING_LEAD_CONTEXT };
  }

  const { claimed } = await leadDoc.claimLead(userDoc.id, userDoc.name);
  if (!claimed) {
    return { success: false, leadNoLongerAvailable: true, reason: ClaimRejectReason.ALREADY_CLAIMED };
  }

  // The claim itself already committed above, so a failure here (history/bookkeeping)
  // must not be reported as a failed claim.
  try {
    await leadDoc.addItemToHistory({
      value: texts.value,
      createdAt: new Date(),
      activityType: LeadHistoryType.CLAIMED_BY_AGENT,
      createdBy: userDoc.id,
      createdByUserName: userDoc.name,
    });
    await userDoc.updateIsISOnCall(false);
  } catch (error) {
    Sentry.captureException(error, { extra: { leadId: leadDoc.id, userId: userDoc.id } });
  }

  return { success: true };
};

const getClaimRejectionText = (reason, rejectionTexts) => (
  reason === ClaimRejectReason.ALREADY_CLAIMED
    ? rejectionTexts.leadAlreadyClaimed
    : rejectionTexts.leadClaimFailed
);

export {
  sendDesktopNotification,
  claimLeadWithHistory,
  getClaimRejectionText,
};
